// Two-click confirmation for destructive actions.
//
// First click arms the element (swaps the label to "Confirm" and adds an armed
// CSS class so the look is styled in CSS, not hard-coded here) and swallows the
// underlying `phx-click`. A second click on the armed element lets the original
// `phx-click` through so the server event fires. Clicking anywhere else, or
// pressing Escape, cancels and restores the element.
//
// Usage: add `phx-hook="ConfirmDelete"` and an `id` to any element that already
// has a `phx-click`. Remove `data-confirm` so the native dialog doesn't also
// appear. Composable via data attributes:
//   data-confirm-label — armed label text (default "Confirm")
//   data-armed-class   — class applied while armed (default "confirm-armed",
//                        styled in app.css; override to restyle per usage)
const DEFAULT_ARMED_CLASS = "confirm-armed";

export const ConfirmDelete = {
  mounted() {
    this.armed = false;
    this.confirmLabel = this.el.dataset.confirmLabel || "Confirm";
    this.armedClass = this.el.dataset.armedClass || DEFAULT_ARMED_CLASS;

    this.onClick = (e) => {
      if (this.armed) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      this.arm();
    };

    this.onCancel = (e) => {
      if (!this.el.contains(e.target)) {
        this.disarm();
      }
    };

    this.onKeyDown = (e) => {
      if (e.key === "Escape") {
        this.disarm();
      }
    };

    this.el.addEventListener("click", this.onClick, true);
  },

  arm() {
    this.armed = true;
    this.originalHTML = this.el.innerHTML;
    this.el.textContent = this.confirmLabel;
    this.el.classList.add(this.armedClass);

    // Register on the next tick so the arming click doesn't immediately cancel.
    setTimeout(() => {
      document.addEventListener("pointerdown", this.onCancel, true);
      document.addEventListener("keydown", this.onKeyDown, true);
    }, 0);
  },

  disarm() {
    if (!this.armed) {
      return;
    }

    this.armed = false;
    this.el.innerHTML = this.originalHTML;
    this.el.classList.remove(this.armedClass);
    this.removeCancelListeners();
  },

  removeCancelListeners() {
    document.removeEventListener("pointerdown", this.onCancel, true);
    document.removeEventListener("keydown", this.onKeyDown, true);
  },

  destroyed() {
    this.removeCancelListeners();
  },
};
